// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Close from '../_raw/ui/icon_close.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Close, { shouldSetDefaultSize: false });
